import ReactGA from 'react-ga4';
import { useMarketplaceConfig } from '../queries/marketplace';
import { useEffect } from 'react';

export const useGoogleAnalytics = () => {
  const { data } = useMarketplaceConfig();

  useEffect(() => {
    const gaId = data?.marketplaceConfig?.googleAnalyticsId;
    if (gaId) {
      ReactGA.initialize(gaId);
    }
  }, [data?.marketplaceConfig?.googleAnalyticsId]);
};
